import { mapGetters } from 'vuex';
import { plansof } from '@/utils/chain';
import { planTypes } from '@/common/constants';
import _ from 'lodash';

export default {
  computed: {
    ...mapGetters([
      'allPbxPlans',
      'allPbxBasePlans',
      'selectedAllPbxPlans',
      'selectedPbxNonBasePlans',
      'selectedPbxBasePlans',
      'selectedPbxBasePlan',
      'selectedTFPlans',
      'selectedTFPlan',
      'pbxBasePlansGroupByBillingCycle',
      'boughtPbxBasePlan',
      'getSelectedPlans',
    ]),
    selectedZoneProPlusCallingPlans() {
      return plansof(this.getSelectedPlans).type(planTypes.ZONE_PRO_PLUS).plans;
    },
    selectedZoneProPlusCallingPlan() {
      return _.get(this.selectedZoneProPlusCallingPlans, [0]);
    },
  },
};
